import { render, staticRenderFns } from "./BuildingIcon.vue?vue&type=template&id=b43c8dd8&scoped=true"
import script from "./BuildingIcon.vue?vue&type=script&lang=ts"
export * from "./BuildingIcon.vue?vue&type=script&lang=ts"
import style0 from "./BuildingIcon.vue?vue&type=style&index=0&id=b43c8dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43c8dd8",
  null
  
)

export default component.exports